// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function indexBy(values, key) {
    return values.reduce((result, value) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const index = value[key];
        result[index] = value;
        return result;
    }, {});
}
